import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface SearchBannerChevronProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    altText: string
}

export const SearchBannerChevron = memo(({templating}: SearchBannerChevronProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName altText />
})
SearchBannerChevron.displayName = "SearchBannerChevron"

export default connect(SearchBannerChevron)
